import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { parse, stringify } from 'query-string';

import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';
import {
  get as getParent,
  post as postParent,
  postStudent,
  patch as patchParent,
} from 'actions/parent-lead';
import { bindActionCreators } from 'redux';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/mobile';
import { COUNTRY_OPTIONS, countryCodeMap } from 'constants/country-code-map';

import Form from 'comps/form';
import { Button, FlexView, Separator, Text } from '@cuemath/comps';
import AddParentForm from './add-parent-form';
import StudentList from './student-list';
import AddParentStudentForm from './add-parent-student-form';
import { MessageText } from './message-text';

const OverflowContainer = styled(FlexView)`
  height: calc(100vh - 60px);
  overflow-y: auto;
`;
const Wrapper = styled(FlexView)`
  @media (min-width: 767px) {
    width: 40%;
    margin: 0 auto;
  }
`;

const FORM = [
  {
    id: 'countryCode',
    label: 'Country Code',
    type: 'dropdown',
    options: COUNTRY_OPTIONS,
  },
  {
    id: 'parentPhone',
    label: 'Enter the parent number',
    type: 'tel',
    autoFocus: true,
    placeholder: 'Enter mobile number',
  },
];

export const Steps = Object.freeze({
  LoadingStep: 0,
  GetParentStep: 1,
  ParentDetailStep: 2,
  AddStudentStep: 3,
});

class AddParentContainer extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      getParent: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.shape({}).isRequired,
    parentLead: PropTypes.shape({}).isRequired,
    searchObj: PropTypes.shape({}).isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    const {
      parentLead,
      searchObj: { phone: searchObjPhone, countryCode: searchObjCountryCode },
    } = props;

    const {
      form: { countryCode: { value, countryName }, parentPhone = '' } = {},
      postParentResponse: { id: postParentResponseId = '' } = {},
      patchParentResponse: { id: patchParentResponseId = '' } = {},
      parentId,
    } = state || {};

    const postParentResponse = store.post(parentLead, postParentResponseId);

    const patchParentResponse = store.patch(parentLead, patchParentResponseId);
    let parsedPhoneNumber = '';

    const postStudentResponse = store.post(parentLead, parentId);

    if (
      countryName &&
      parentPhone &&
      value &&
      AddParentContainer.checkIfNumberIsValid(countryName, parentPhone)
    ) {
      parsedPhoneNumber = AddParentContainer.getParsedPhoneNumber(
        countryName,
        parsedPhoneNumber,
        parentPhone,
      );
    }
    parsedPhoneNumber = AddParentContainer.getParentNumber(
      parsedPhoneNumber,
      parentPhone,
      searchObjPhone,
    );
    const parent = store.get(parentLead, parsedPhoneNumber, {
      phone: parsedPhoneNumber,
      country_code: searchObjCountryCode || value,
    });
    const { isLoading, isLoaded, isLoadingFailed } = parent || {};
    const { resolved } = postParentResponse;
    let { error, step, genericError } = state;

    if (!searchObjPhone) {
      step = Steps.GetParentStep;
    }
    if (parent && isLoading) {
      genericError = null;
      step = Steps.LoadingStep;
    } else if (parent && isLoadingFailed) {
      step = Steps.GetParentStep;
      genericError = { message: 'Something went wrong. Please try again!' };
    }

    if (parent && isLoaded && searchObjPhone) {
      genericError = null;
      step = Steps.ParentDetailStep;
    }

    if (resolved) {
      if (resolved.isCreatingFailed) {
        error = store.getError(resolved);
      } else if (resolved.isCreated) {
        const {
          data: { id, phone },
        } = resolved;

        error = {};
      }
    }

    return {
      postParentResponse,
      postStudentResponse,
      patchParentResponse,
      error,
      parent,
      step,
      genericError,
      parsedPhoneNumber,
    };
  }

  state = {
    step: Steps.GetParentStep,
    postParentResponse: store.post(),
    // postStudentResponse: store.post(),
    patchParentResponse: store.patch(),
    error: {},
    form: {
      countryCode: { value: '', label: '', countryName: '' },
      parentPhone: '',
    },
    validation: {},
    genericError: {},
  };

  static getParentNumber(parsedPhoneNumber, parentPhone, searchObjPhone) {
    return parsedPhoneNumber.length > 0
      ? parsedPhoneNumber
      : parentPhone || searchObjPhone;
  }

  componentDidMount() {
    const {
      searchObj: { phone },
    } = this.props;

    if (phone) {
      this.refreshData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchObj: prevSearch } = prevProps;
    const { phone: prevPhone } = prevSearch || {};
    const {
      searchObj: { phone },
    } = this.props;
    const { parent, postParentResponse } = this.state;
    const { postParentResponse: prevPostParentResponse } = prevState;

    const { isLoaded, isLoading } = parent ? parent : {};

    if (prevPhone !== phone && (!parent || (parent && !isLoading && !isLoaded))) {
      this.refreshData();
    }

    const { resolved } = postParentResponse || {};
    const { data, isCreated } = resolved || {};
    const { resolved: prevResolved } = prevPostParentResponse || {};
    const { isCreated: prevIsCreated } = prevResolved || {};
    const { parent_id: parentId } = data || {};
    if (!prevIsCreated && isCreated) {
      this.setState({ parentId });
    }
  }

  refreshData = () => {
    const {
      actions,
      searchObj: { phone: searchObjPhone, countryCode: searchObjCountryCode },
    } = this.props;

    const {
      form: {
        parentPhone: phone,
        countryCode: { value, countryName },
      },
    } = this.state;

    let parsedPhoneNumber;

    if (countryName) {
      parsedPhoneNumber = AddParentContainer.getParsedPhoneNumber(
        countryName,
        parsedPhoneNumber,
        phone,
      );
    }
    const phoneNumber = (countryName ? parsedPhoneNumber : phone) || searchObjPhone;

    actions.getParent(phoneNumber, {
      phone: phoneNumber,
      country_code: searchObjCountryCode || value,
    });
  };

  onFormChange = (nextData, nextValidation) => {
    const formData = {};

    Object.keys(nextData).forEach(k => {
      formData[k] = (nextData[k].target && nextData[k].target.value) || nextData[k];
    });

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        ...formData,
      },
      validation: {
        ...prevState.validation,
        ...nextValidation,
      },
      genericError: {
        ...prevState.genericError,
        message: '',
      },
    }));
  };

  errorMessage = (value, parentPhone, countryName) => {
    if (!value) {
      return 'Country code is required';
    }
    if (!parentPhone || typeof parentPhone !== 'string') {
      return 'Parent number is required';
    }

    // const isValidNumber = AddParentContainer.checkIfNumberIsValid(
    //   countryName,
    //   parentPhone,
    // );

    // if (!isValidNumber) {
    //   return 'Mobile number entered is invalid. Please check again.';
    // }

    return null;
  };

  onSubmit = event => {
    const { history } = this.props;
    const {
      form: {
        parentPhone,
        countryCode: { value, countryName },
      },
    } = this.state;

    event.preventDefault();

    const errorMessage = this.errorMessage(value, parentPhone, countryName);
    if (errorMessage) {
      this.setState({
        genericError: {
          message: errorMessage,
        },
      });
    } else {
      const parsedPhoneNumber = AddParentContainer.getParsedPhoneNumber(
        countryName,
        parsedPhoneNumber,
        parentPhone,
      );
      history.push(
        `?${stringify({ phone: parsedPhoneNumber })}&${stringify({
          countryCode: value,
        })}`,
      );
    }
  };

  static getParsedPhoneNumber(countryName, parsedPhoneNumber, parentPhone) {
    const countryCode = AddParentContainer.getGeoIPCountryCode(countryName);
    parsedPhoneNumber = parsePhoneNumber(parentPhone, countryCode).nationalNumber;
    return parsedPhoneNumber;
  }

  static getGeoIPCountryCode(countryName) {
    const selectedCountry = countryCodeMap.filter(countrymap => {
      return countrymap.id === countryName;
    });
    const { geoIPCountryCode = '' } = selectedCountry[0] || {};
    return geoIPCountryCode;
  }

  static checkIfNumberIsValid(countryName, parentPhone) {
    const countryCode = AddParentContainer.getGeoIPCountryCode(countryName);
    return isValidPhoneNumber(parentPhone, countryCode);
  }

  render() {
    const {
      form,
      validation,
      error,
      step,
      genericError,
      parent,
      postParentResponse,
      postStudentResponse,
      patchParentResponse,
      parsedPhoneNumber,
      parentId,
    } = this.state;
    const { actions } = this.props;

    const { message } = genericError || {};
    const { data = {} } = parent || {};
    const { leads = {}, parent_id: leadParentId } = data || {};
    const { phone = '' } = leads || {};
    const numberOfLeads = leads.length;
    const { parent_service_id: parentServiceId = '' } = leads[0] || {};
    const { parentPhone = {} } = form || {};

    return (
      <OverflowContainer gutter>
        <Wrapper>
          {message && <MessageText message={message} />}
          <Text size="larger" weight="bolder">
            Add a new student
          </Text>
          <Separator height={5} transparent />
          {step === Steps.LoadingStep && <>Loading</>}
          {step === Steps.GetParentStep && (
            <form onSubmit={this.onSubmit}>
              <Form
                nodes={FORM}
                values={form}
                validations={validation}
                error={error}
                onChange={this.onFormChange}
              />

              <Button
                renderAs="primary"
                label="Continue"
                disabled={parent && parent.isLoading}
                busy={parent && parent.isLoading}
              />
            </form>
          )}
        </Wrapper>
        {step === Steps.ParentDetailStep && (
          <>
            <Wrapper>
              {numberOfLeads === 0 ? (
                <AddParentStudentForm
                  parentData={parent && parent.data}
                  primaryNumber={parsedPhoneNumber}
                  postParent={actions.postParent}
                  postStudent={actions.postStudent}
                  postParentResponse={postParentResponse}
                  postStudentResponse={postStudentResponse}
                  parentId={parentId}
                />
              ) : (
                <AddParentForm
                  parentData={parent && data}
                  primaryNumber={parsedPhoneNumber}
                  postParent={actions.postParent}
                  patchParent={actions.patchParent}
                  postParentResponse={postParentResponse}
                  patchParentResponse={patchParentResponse}
                  refreshData={this.refreshData}
                />
              )}
            </Wrapper>

            {numberOfLeads > 0 && (
              <StudentList
                studentLeads={parent && leads}
                parentId={leadParentId}
                parentPhone={parsedPhoneNumber}
              />
            )}
          </>
        )}
        <Separator height={90} transparent />
      </OverflowContainer>
    );
  }
}

export default connect(
  ({ parentLead }, { location: { search } = {} }) => {
    const searchObj = parse(search);

    return {
      parentLead,
      searchObj,
    };
  },
  dispatch => ({
    actions: bindActionCreators(
      { getParent, postParent, postStudent, patchParent },
      dispatch,
    ),
  }),
)(AddParentContainer);
